<form class="animated faster fadeInRight" (ngSubmit)="requestReset()" [formGroup]="form">
  <div class="pb-2">
    <div class="form-group">
      <py-reactive-form-input-field
        [group]="form"
        [label]="'password.forgotten.email_heading' | cxTranslate"
        [resettable]="true"
        fieldName="email"
        inputType="email"
        (enterEvent)="requestReset()"
        (handleReset)="onResetInput('email')"
      ></py-reactive-form-input-field>
    </div>
    <ng-container *ngIf="needsUsername">
      <div class="form-group">
        <py-reactive-form-input-field
          [group]="form"
          [label]="'password.forgotten.username_heading' | cxTranslate"
          [resettable]="true"
          fieldName="username"
          inputType="text"
          (enterEvent)="requestReset()"
          (handleReset)="onResetInput('username')"
        ></py-reactive-form-input-field>
      </div>
    </ng-container>
  </div>

  <py-action-button
    [success]="success"
    [error]="error"
    [loading]="loading"
    [type]="'submit'"
    [buttonLabel]="'password.forgotten.submit_action' | cxTranslate"
    [disabled]="form.invalid || !form.dirty || !isEmailChecked"
    [buttonClass]="'btn btn-primary w-100 animated'"
    [spinnerType]="'dark'"
  >
  </py-action-button>
</form>
